module.exports = __webpack_public_path__ + "img/worksbot_img20021110.c896cf1a.jpg";